import { render, staticRenderFns } from "./DashboardProgress.vue?vue&type=template&id=9f4c9226&scoped=true&"
import script from "./DashboardProgress.vue?vue&type=script&lang=ts&"
export * from "./DashboardProgress.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardProgress.vue?vue&type=style&index=0&id=9f4c9226&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4c9226",
  null
  
)

export default component.exports